import { Input, Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {UserService} from "../../../services/user.service";
import {AppDataService} from "../../../services/app-data.service";
import {InstagramUserBean} from "../../../beansts/instagram.user.bean";
import {EventBean} from "../../../beansts/Event";
import {CompanyBean} from "../../../beansts/company.bean";
import { TranslationService } from '../../../services/translation.service';

import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
declare let $: any;
declare var Swal : any;

@Component({
    selector : 'footer-component',
    templateUrl:'footer-component.html',

})
export class FooterComponent implements OnInit, OnDestroy{

    public contactForm

  public constructor( private _router : Router,public translate: TranslationService,private _auth : UserService,public _appData : AppDataService,private fb : FormBuilder, private _companyService : CompanyService) {
 

    }

    public ngOnInit(): any {
      this.contactForm= this.fb.group({
        userEmail: '',
      });

    }

    public onChange (params){
      this.ngOnInit();
  };

    public ngOnDestroy() : any {
    }




  
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+header-footer/footer/footer-component.ts